import React from 'react';
import styled from 'styled-components';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import { useTheme } from '../../contexts/ThemeContext';

const Bar = styled.div`
  display: none;
  width: 100%;
  justify-content: center;
  @media (max-width: 600px) {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
    align-items: center;
    margin-top: 0.25rem;
  }
`;

const Pill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.72rem;
  padding: 0.28rem 0.5rem;
  border-radius: 0.35rem;
  border: 1px solid ${(props) => props.theme.primary};
  background: ${(props) => props.theme.inputBg};
  color: ${(props) => props.theme.primaryText};
  cursor: pointer;
  box-shadow: ${(props) => props.theme.shadow};
  transition: border-color 0.15s ease;
  &:hover,
  &:focus {
    border-color: ${(props) => props.theme.primaryHover};
    outline: none;
  }
`;

/**
 * Compact probability / odds / edge sort controls for narrow viewports (table is hidden; cards have no column headers).
 *
 * @param {string} [props.probabilityColumn] - Row field used for default model sort (e.g. predicted_hit_prob). Omit to hide the Probability pill.
 * @param {string} [props.probabilityLabel] - Short label for the probability pill (default "Probability").
 */
export default function OddsEdgeMobileSortBar({
  sortColumn,
  sortDirection,
  onSort,
  probabilityColumn,
  probabilityLabel = 'Probability',
}) {
  const { theme } = useTheme();
  const sortIcon = (col) =>
    sortColumn === col ? (
      sortDirection === 'asc' ? (
        <FaSortUp aria-hidden />
      ) : (
        <FaSortDown aria-hidden />
      )
    ) : (
      <FaSort style={{ opacity: 0.45 }} aria-hidden />
    );
  return (
    <Bar>
      {probabilityColumn ? (
        <Pill
          type="button"
          theme={theme}
          onClick={() => onSort(probabilityColumn)}
          aria-label={`Sort by ${probabilityLabel}`}
        >
          {probabilityLabel}
          {sortIcon(probabilityColumn)}
        </Pill>
      ) : null}
      <Pill type="button" theme={theme} onClick={() => onSort('odds')} aria-label="Sort by odds">
        Odds
        {sortIcon('odds')}
      </Pill>
      <Pill type="button" theme={theme} onClick={() => onSort('edge')} aria-label="Sort by edge">
        Edge
        {sortIcon('edge')}
      </Pill>
    </Bar>
  );
}
